module.exports = __webpack_public_path__ + "img/ico-peripatetic.a0521085.svg";